import { tabNavigatorContext } from './TabNavigatorContext';

export const useTabNavigatorMatch = index => {
  const [activeIndex] = tabNavigatorContext();

  return activeIndex === index;
};
